import classNames from 'classnames'
import React, { useRef } from 'react'
import { useForm } from 'react-hook-form'

const BrewActivityForm = ({ brew, formAuthenticityToken, kindsForSelect, labels, quantityUnitsForSelect, supplies, title }) => {
  const { formState: { errors }, handleSubmit, register, watch } = useForm()
  const formRef = useRef()

  const kind = watch('brew_activity[kind]')
  const supplyId = watch('brew_activity[supply_id]')

  const supply = supplies.find(s => s.id === parseInt(supplyId))

  const onSubmit = (data) => {
    formRef.current.submit()
  }

  return (
    <div className='card mb-3'>
      <div className='card-body'>
        <h5 className='card-title'>{title}</h5>

        <form action={`/brews/${brew.id}/brew_activities`} method='POST' ref={formRef} onSubmit={handleSubmit(onSubmit)}>
          <input type='hidden' name='authenticity_token' value={formAuthenticityToken} autoComplete='off' />

          <div className='mb-3'>
            <label
              className={classNames('form-label', { 'is-invalid': errors.brew_activity?.kind })}
            >
              {labels.kind}
            </label>
            <select
              className={classNames('form-control', { 'is-invalid': errors.brew_activity?.kind })}
              {...register('brew_activity[kind]', { required: true })}
            >
              <option />
              {kindsForSelect.map(kind => <option key={kind.value} value={kind.value}>{kind.label}</option>)}
            </select>
            {errors.brew_activity?.kind && <div className='invalid-feedback'>no puede estar en blanco</div>}
          </div>

          {(kind === 'dry_hopping' || kind === 'fruit_adding') && (
            <>
              <div className='mb-3'>
                <label
                  className={classNames('form-label', { 'is-invalid': errors.brew_activity?.temperature })}
                >
                  {labels.temperature}
                </label>
                <input
                  type='number'
                  step='0.1'
                  className={classNames('form-control', { 'is-invalid': errors.brew_activity?.temperature })}
                  {...register('brew_activity[temperature]', { required: kind === 'dry_hopping' })}
                />
                {errors.brew_activity?.temperature && <div className='invalid-feedback'>no puede estar en blanco</div>}
              </div>

              <div className='mb-3'>
                <label
                  className={classNames('form-label', { 'is-invalid': errors.brew_activity?.supply_id })}
                >
                  {labels.supplyId}
                </label>
                <select
                  className={classNames('form-control', { 'is-invalid': errors.brew_activity?.supply_id })}
                  {...register('brew_activity[supply_id]', { required: kind === 'dry_hopping' })}
                >
                  <option />
                  {supplies.map(supply => <option key={supply.id} value={supply.id}>{supply.name}</option>)}
                </select>
                {errors.brew_activity?.supply_id && <div className='invalid-feedback'>no puede estar en blanco</div>}
              </div>

              <div className='form-row mb-3'>
                <div className='col'>
                  <label
                    className={classNames('form-label', { 'is-invalid': errors.brew_activity?.quantity })}
                  >
                    {labels.quantity}
                  </label>
                  <input
                    type='number'
                    step='0.001'
                    className={classNames('form-control', { 'is-invalid': errors.brew_activity?.quantity })}
                    {...register('brew_activity[quantity]', {
                      required: kind === 'dry_hopping',
                      validate: { max: v => v <= supply?.quantity }
                    })}
                  />
                  {errors.brew_activity?.quantity?.type === 'required' && <div className='invalid-feedback'>no puede estar en blanco</div>}
                  {errors.brew_activity?.quantity?.type === 'max' && <div className='invalid-feedback'>no puede ser mayor que {supply.quantity} {supply.quantityUnit}</div>}
                </div>

                <div className='col'>
                  <label
                    className={classNames('form-label', { 'is-invalid': errors.brew_activity?.quantity_unit })}
                  >
                    {labels.quantityUnit}
                  </label>
                  <select
                    className={classNames('form-control', { 'is-invalid': errors.brew_activity?.quantity_unit })}
                    {...register('brew_activity[quantity_unit]', { required: true })}
                  >
                    <option />
                    {quantityUnitsForSelect.map(qu => <option key={qu.value} value={qu.value}>{qu.label}</option>)}
                  </select>
                  {errors.brew_activity?.quantity_unit && <div className='invalid-feedback'>no puede estar en blanco</div>}
                </div>
              </div>
            </>
          )}

          <div className='mb-3'>
            <label className='form-label'>{labels.comment}</label>
            <textarea className='form-control' {...register('brew_activity[comment]')} />
          </div>

          <div className='actions'>
            <input type='submit' name='commit' value={labels.submit} className='btn btn-primary' />
          </div>
        </form>
      </div>
    </div>
  )
}

export default BrewActivityForm
